{
  "common": {
    "edit": "Redigera",
    "delete": "Radera",
    "save": "Spara",
    "cancel": "Avbryt",
    "loading": "Laddar...",
    "error": "Fel",
    "success": "Framgång",
    "noData": "Ingen data tillgänglig",
    "yes": "Ja",
    "no": "Nej",
    "admin": "Admin",
    "user": "Användare",
    "actions": "Åtgärder",
    "home": "Hem",
    "companies": "Företag",
    "create": "Skapa",
    "details": "Detaljer",
    "import": "Importera",
    "settings": "Inställningar",
    "subscription": "Prenumeration",
    "member": "Medlem",
    "users": "Användare",
    "integrations": "Integrationer",
    "refresh": "Uppdatera",
    "loadMore": "Ladda fler"
  },
  "companyDetails": {
    "title": "Företagsdetaljer",
    "overview": {
      "title": "Översikt",
      "subtitle": "Viktiga affärsmått och information",
      "crmId": "CRM-ID",
      "status": "Status",
      "mrr": "MRR",
      "leadSource": "Leadkälla",
      "market": "Marknad",
      "industry": "Bransch",
      "activityLevel": "Aktivitetsnivå",
      "leadStatus": "Leadstatus"
    },
    "ownership": {
      "title": "Ägarskap & Personer",
      "subtitle": "Teammedlemmar och ägarinformation",
      "owner": "Ägare",
      "salesRep": "Säljare",
      "csmId": "CSM-ID"
    },
    "dates": {
      "title": "Datum & Metadata",
      "subtitle": "Viktiga datum och registerinformation",
      "createdDate": "Skapad datum",
      "recordCreated": "Post skapad"
    },
    "customFields": {
      "title": "Anpassade fält",
      "subtitle": "Ytterligare information om anpassade fält",
      "noFields": "Inga anpassade fält definierade för detta konto.",
      "configureLink": "Konfigurera anpassade fält"
    },
    "history": {
      "title": "Ändringshistorik",
      "subtitle": "Spåra alla ändringar och uppdateringar för detta företag",
      "addRecord": "Lägg till post"
    },
    "actions": {
      "editTooltip": "Redigera detta företag",
      "deleteTooltip": "Radera denna företagspost",
      "deleteConfirmTitle": "Radera företagspost?",
      "deleteConfirmDescription": "Är du säker på att du vill radera denna företagspost?",
      "deleteSuccess": "Företagspost raderad framgångsrikt",
      "deleteSuccessNavigate": "Företagspost raderad framgångsrikt. Navigera tillbaka till företagslistan",
      "deleteError": "Kunde inte radera företagspost",
      "fetchError": "Fel vid hämtning av data"
    },
    "empty": {
      "title": "Ingen företagsdata tillgänglig",
      "description": "Företagsinformationen kunde inte laddas."
    },
    "status": {
      "na": "N/A",
      "lead": "Lead",
      "opportunity": "Möjlighet",
      "customer": "Kund"
    }
  },
  "dashboard": {
    "metrics": {
      "totalCompanies": "Totalt antal företag",
      "customers": "Kunder",
      "leads": "Leads",
      "churned": "Avbrutna"
    },
    "cards": {
      "companiesStatusDistribution": "Företagsstatusfördelning",
      "dataSourceAnalytics": "Datakällanalys",
      "recentCompanies": "Senaste företag",
      "viewAllCompanies": "Visa alla företag",
      "added": "Tillagd",
      "source": "Källa"
    },
    "status": {
      "opportunity": "Möjlighet",
      "lead": "Lead",
      "lostLead": "Förlorad lead",
      "customer": "Kund",
      "churned": "Avbruten",
      "lostOpportunity": "Förlorad möjlighet"
    },
    "dataSource": {
      "hubspot": "HubSpot",
      "importXls": "Excel-import",
      "manual": "Manuell inmatning",
      "zapier": "Zapier",
      "total": "Totalt",
      "numberOfCompanies": "Antal företag",
      "companySourceDistribution": "Företagskällfördelning",
      "companiesBySource": "Företag per källa",
      "averageCustomerValueBySource": "Genomsnittligt kundvärde per källa"
    },
    "errors": {
      "loadCompaniesData": "Kunde inte ladda företagsdata",
      "loadRecentCompanies": "Kunde inte ladda senaste företag"
    },
    "totalCompanies": "Totalt antal företag"
  },
  "companies": {
    "list": {
      "title": "Mina företag",
      "total": "Totalt",
      "searchPlaceholder": "Sök företag...",
      "importFile": "Importera fil",
      "import": "Importera",
      "exportXls": "Exportera XLS",
      "export": "Exportera",
      "newCompany": "Nytt företag",
      "new": "Ny",
      "exportCurrentState": "Exportera nuvarande tillstånd",
      "exportAll": "Exportera alla",
      "columns": {
        "name": "Namn",
        "mrr": "MRR",
        "status": "Status",
        "lastUpdated": "Senast uppdaterad"
      },
      "errors": {
        "exportError": "Fel vid export av XLS-fil:",
        "limitReached": "Företagsgräns nådd. Uppgradera din plan för att importera fler företag.",
        "exportLimitReached": "Företagsgräns nådd. Endast begränsade företag kommer att exporteras. Uppgradera din plan för att exportera alla företag.",
        "listLimitReached": "Företagsgräns nådd. Endast begränsade företag är synliga. Uppgradera din plan för att se alla företag."
      },
      "limitBanner": {
        "title": "Företagsgräns nådd",
        "message": "Du har nått din plans gräns på {{max}} företag (för närvarande {{current}}). Vissa funktioner kan vara begränsade.",
        "upgrade": "Uppgradera plan",
        "upgradeLink": "Uppgradera din plan"
      }
    },
    "create": {
      "title": "Skapa ny företagspost",
      "duplicatedRecord": "Duplicerad post",
      "duplicateInfo": "Detta formulär är förifyllt med data från en befintlig post. Uppdatera fältet Skapad datum för att skapa en ny post.",
      "sections": {
        "generalInformation": "Allmän information",
        "financialStatus": "Finansiell & statusinformation",
        "contactInformation": "Kontaktinformation",
        "marketInformation": "Marknadsinformation",
        "activityInformation": "Aktivitetsinformation",
        "otherInformation": "Övrig information",
        "customFields": "Anpassade fält"
      },
      "fields": {
        "companyName": "Företagsnamn",
        "crmId": "CRM-ID",
        "companyOwner": "Företagsägare",
        "mrr": "MRR",
        "companyStatus": "Företagsstatus",
        "leadStatus": "Leadstatus",
        "customerSuccessManagerId": "Kundframgångsansvarig ID",
        "organizationNumber": "Organisationsnummer",
        "salesRepresentative": "Säljrepresentant",
        "market": "Marknad",
        "industry": "Bransch",
        "leadSource": "Leadkälla",
        "activityLevel": "Aktivitetsnivå",
        "companyActive": "Företag aktivt?",
        "dateCreated": "Skapad datum"
      },
      "statusOptions": {
        "lead": "Lead",
        "lostLead": "Förlorad lead",
        "opportunity": "Möjlighet",
        "customer": "Kund",
        "churnedCustomer": "Avbruten kund",
        "lostOpportunity": "Förlorad möjlighet"
      },
      "leadStatusOptions": {
        "open": "Öppen",
        "lost": "Förlorad",
        "won": "Vunnen"
      },
      "customFieldsHelper": "Max 255 tecken. Tom sträng behåller tomt värde.",
      "loadingCustomFields": "Laddar anpassade fält...",
      "duplicateWarning": "Viktigt: Ändra Skapad datum för att skapa en ny post. Poster med samma datum kan inte tillåtas.",
      "actions": {
        "cancel": "Avbryt",
        "createRecord": "Skapa post"
      },
      "errors": {
        "loadCustomFields": "Kunde inte ladda anpassade fält",
        "createError": "Kunde inte skapa företag",
        "createSuccess": "Företag skapat framgångsrikt"
      },
      "validation": {
        "companyNameRequired": "Företagsnamn krävs",
        "companyNameMin": "Företagsnamn måste vara minst 3 tecken",
        "mrrRequired": "MRR krävs",
        "mrrMin": "MRR bör vara 0 eller positivt",
        "crmIdRequired": "CRM-ID krävs",
        "crmIdMin": "CRM-ID måste vara minst 1 tecken",
        "statusRequired": "Status krävs",
        "statusInvalid": "Ogiltig status",
        "leadStatusRequired": "Leadstatus krävs",
        "leadStatusInvalid": "Ogiltig leadstatus",
        "dateCreatedRequired": "Skapad datum krävs",
        "errorsSummary": "Åtgärda följande fel:"
      }
    },
    "edit": {
      "title": "Uppdatera företag",
      "updateTitle": "Uppdatera företagspost",
      "sections": {
        "generalInformation": "Allmän information",
        "financialStatus": "Finansiell & statusinformation",
        "contactInformation": "Kontaktinformation",
        "marketInformation": "Marknadsinformation",
        "activityInformation": "Aktivitetsinformation",
        "otherInformation": "Övrig information",
        "customFields": "Anpassade fält"
      },
      "fields": {
        "companyName": "Företagsnamn",
        "crmId": "CRM-ID",
        "companyOwner": "Företagsägare",
        "mrr": "MRR",
        "companyStatus": "Företagsstatus",
        "leadStatus": "Leadstatus",
        "customerSuccessManagerId": "Kundframgångsansvarig ID",
        "organizationNumber": "Organisationsnummer",
        "salesRepresentative": "Säljrepresentant",
        "market": "Marknad",
        "industry": "Bransch",
        "leadSource": "Leadkälla",
        "activityLevel": "Aktivitetsnivå",
        "companyActive": "Företag aktivt?",
        "dateCreated": "Skapad datum"
      },
      "statusOptions": {
        "lead": "Lead",
        "lostLead": "Förlorad lead",
        "opportunity": "Möjlighet",
        "customer": "Kund",
        "churnedCustomer": "Avbruten kund",
        "lostOpportunity": "Förlorad möjlighet"
      },
      "leadStatusOptions": {
        "open": "Öppen",
        "lost": "Förlorad",
        "won": "Vunnen"
      },
      "customFieldsHelper": "Max 255 tecken. Tom sträng behåller tomt värde.",
      "loadingCustomFields": "Laddar anpassade fält...",
      "actions": {
        "cancel": "Avbryt",
        "updateRecord": "Uppdatera post"
      },
      "validation": {
        "errorsSummary": "Åtgärda följande fel:"
      },
      "errors": {
        "loadCustomFields": "Kunde inte ladda anpassade fält",
        "loadCustomFieldValues": "Kunde inte ladda anpassade fältvärden",
        "updateError": "Kunde inte uppdatera företag.",
        "updateSuccess": "Företag uppdaterat framgångsrikt",
        "fetchError": "Fel vid hämtning av data"
      }
    },
    "import": {
      "title": "Importera företag",
      "selectExcelFile": "Välj Excel-fil",
      "downloadTemplate": "Ladda ner mall",
      "dragDropText": "Dra & släpp din Excel (.xlsx eller .xls) fil här",
      "clickToBrowse": "eller klicka för att bläddra",
      "selectedFile": "Vald fil:",
      "fileInfo": "Se till att dina kolumner matchar mallen. Endast .xlsx eller .xls filer upp till 10MB stöds.",
      "fileDetails": {
        "size": "Storlek",
        "type": "Typ",
        "lastModified": "Senast ändrad"
      },
      "actions": {
        "importFile": "Importera fil",
        "importing": "Importerar…",
        "importingProgress": "Importerar… {{progress}}%",
        "replaceFile": "Ersätt fil",
        "remove": "Ta bort"
      },
      "results": {
        "title": "Importresultat",
        "rowsInDuration": "{{count}} rader på {{duration}}s",
        "success": "Framgång",
        "errors": "Fel",
        "clearResults": "Rensa resultat",
        "all": "Alla ({{count}})",
        "successCount": "Framgång ({{count}})",
        "errorCount": "Fel ({{count}})",
        "tableHeaders": {
          "rowId": "Rad-ID",
          "name": "Namn",
          "crmId": "CRM-ID",
          "result": "Resultat",
          "errors": "Fel"
        },
        "importError": "Importfel"
      },
      "errors": {
        "noFileSelected": "Välj en fil att ladda upp.",
        "fileRequired": "Välj en fil.",
        "invalidExtension": "Endast .xlsx eller .xls filer stöds.",
        "fileTooLarge": "Filen är för stor (max 10MB).",
        "importSuccess": "Företag importerade framgångsrikt",
        "importFailed": "Kunde inte importera XLS-fil",
        "limitReached": "Företagsgräns nådd. Uppgradera din plan för att importera fler företag."
      }
    }
  },
  "menu": {
    "dashboard": {
      "title": "Meny",
      "items": {
        "default": "Instrumentpanel",
        "feed": "Flöde",
        "companies": "Företag"
      }
    },
    "settings": {
      "title": "Inställningar",
      "items": {
        "settings": "Inställningar",
        "team": "Mitt team",
        "customFields": "Anpassade fält",
        "subscription": "Min prenumeration",
        "billing": "Fakturering",
        "plan": "Plan",
        "crmIntegrations": "CRM-integrationer",
        "overview": "Översikt",
        "hubspot": "Hubspot CRM",
        "zapier": "Zapier"
      }
    }
  },
  "aiChat": {
    "title": "AI-assistent",
    "startNewChat": "Starta ny chatt",
    "empty": "Starta en konversation genom att skicka ett meddelande",
    "typing": "AI skriver...",
    "composerPlaceholder": "Skriv ditt meddelande...",
    "examples": {
      "heading": "Hur kan jag hjälpa dig idag?",
      "subheading": "Prova ett av dessa exempel för att komma igång",
      "companyOperations": "Företagsåtgärder",
      "teamOperations": "Teamåtgärder",
      "userOperations": "Användaråtgärder",
      "createCompany": "Skapa ett företag som heter Acme Corp",
      "renameCompany": "Byt namn på företaget till New Name",
      "renameTeam": "Byt namn på teamet till Acme Corp",
      "changeTeamName": "Ändra teamnamnet till New Name",
      "inviteAdmin": "Bjud in john@example.com till teamet som admin",
      "inviteUser": "Bjud in user@example.com med användarroll"
    },
    "tool": {
      "inviteUser": "Bjud in användare:",
      "email": "E-post:",
      "role": "Roll:",
      "adminsOnly": "Obs: Endast teamadministratörer kan bjuda in användare",
      "renameTeam": "Byt namn på team:",
      "renameCompany": "Byt namn på företag:",
      "newTeamName": "Nytt teamnamn: {{name}}",
      "details": "Detaljer:",
      "userInvited": "Användaren {{email}} har bjudits in till teamet med rollen: {{role}}",
      "teamRenamed": "Teamet har bytt namn till \"{{name}}\"",
      "companyRenamed": "Företaget har bytt namn till \"{{name}}\"",
      "viewCompany": "Visa företag",
      "success": "Verktyget kördes framgångsrikt",
      "approve": "Godkänn",
      "deny": "Neka"
    }
  },
  "breadcrumbs": {
    "importXlsx": "Importera XLSX-fil",
    "trash": "Papperskorg",
    "spam": "Skräppost",
    "drafts": "Utkast",
    "paymentSuccess": "Betalning lyckades",
    "paymentError": "Betalningsfel",
    "customFields": "Anpassade fält",
    "updateCompany": "Uppdatera företag"
  },
  "notifications": {
    "title": "Notiser",
    "all": "Alla notiser",
    "emptyTitle": "Inga notiser ännu",
    "emptyDescription": "När du har notiser visas de här",
    "loading": "Laddar...",
    "noMore": "Inga fler notiser",
    "dismiss": "Avfärda",
    "read": "Läst",
    "new": "Ny",
    "unknownTime": "Okänd tid",
    "viewAll": "Visa alla notiser",
    "ariaLabel": "Notis: {{message}}"
  },
  "layout": {
    "theme": {
      "toggle": "Växla färgtema"
    },
    "footer": {
      "version": "Metafor · v"
    },
    "profile": {
      "hello": "Hej,",
      "team": "Team {{role}}",
      "profileSettings": "Profilinställningar",
      "logout": "Logga ut",
      "teamSelection": "Teamval",
      "selectTeam": "Välj team",
      "yourTeams": "Dina team"
    },
    "upgradeCard": {
      "upgradeTitle": "Uppgradera din plan",
      "unlock": "Lås upp premiumfunktioner:",
      "unlimitedIntegrations": "Obegränsade integrationer",
      "moreUsersCompanies": "Fler användare och företag",
      "advancedFeatures": "Avancerade funktioner",
      "goPremium": "Gå Premium",
      "premiumActive": "Premiumplan aktiv",
      "activeUntil": "Aktiv till",
      "premiumAccess": "Din plan förnyas automatiskt. <br /> Du har tillgång till alla premiumfunktioner.",
      "manageSubscription": "Hantera prenumeration"
    },
    "sidebar": {
      "myPlan": "Min plan",
      "goToSubscription": "Gå till min prenumeration",
      "menuItemsError": "Menyfel",
      "mailboxFolders": "brevlådemappar"
    },
    "header": {
      "openCityView": "Öppna stadsvy"
    }
  },
  "auth": {
    "brandHeadline": "Kalkylblad motiverar inte. Metaforer gör det.",
    "brandSubtitle": "Visualisera din verksamhet — varje byggnad en kund, varje skyline en berättelse.",
    "welcomeBack": "Välkommen tillbaka",
    "enterCredentials": "Ange dina uppgifter för att fortsätta",
    "noAccount": "Har du inget konto?",
    "alreadyHaveAccount": "Har du redan ett konto?",
    "signInWithGoogle": "Logga in med Google",
    "signUpWithGoogle": "Registrera dig med Google",
    "or": "ELLER",
    "signInWithEmail": "Logga in med e-postadress",
    "signUpWithEmail": "Registrera dig med e-postadress",
    "emailAddress": "E-postadress",
    "emailUsername": "E-postadress / användarnamn",
    "password": "Lösenord",
    "rememberMe": "Kom ihåg mig",
    "forgotPassword": "Glömt lösenord?",
    "signIn": "Logga in",
    "signUp": "Registrera dig",
    "firstName": "Förnamn",
    "lastName": "Efternamn",
    "agreeWith": "Godkänn",
    "terms": "Villkor.",
    "togglePassword": "växla lösenordets synlighet",
    "loginSuccess": "Inloggningen lyckades",
    "invalidCredentials": "Fel användarnamn eller lösenord",
    "registerSuccess": "Användaren registrerades. Kontrollera din e-post för att aktivera kontot",
    "registerError": "Kunde inte registrera användare",
    "validation": {
      "validEmail": "Ange en giltig e-postadress",
      "emailRequired": "E-post krävs",
      "passwordRequired": "Lösenord krävs",
      "firstNameMin": "Förnamnet måste vara minst 2 tecken",
      "firstNameRequired": "Förnamn krävs",
      "lastNameMin": "Efternamnet måste vara minst 2 tecken",
      "lastNameRequired": "Efternamn krävs"
    },
    "resetPassword": {
      "title": "Återställ lösenord",
      "subtitle": "Ange din e-postadress för att få en återställningslänk",
      "send": "Skicka återställningsmejl",
      "sentMessage": "Om ett konto med den e-postadressen finns får du snart ett mejl för återställning av lösenordet.",
      "backToLogin": "Tillbaka till inloggning",
      "requestSent": "Begäran om återställning skickad",
      "requestError": "Kunde inte skicka begäran om återställning",
      "setTitle": "Ange nytt lösenord",
      "setSubtitle": "Ange ditt nya lösenord nedan",
      "setSuccess": "Ditt lösenord har sparats. Du kan nu logga in med ditt nya lösenord.",
      "backToLoginLower": "Tillbaka till inloggning",
      "newPassword": "Nytt lösenord",
      "confirmPassword": "Bekräfta lösenord",
      "setPassword": "Spara lösenord",
      "passwordMin": "Lösenordet måste vara minst 8 tecken",
      "passwordsMatch": "Lösenorden måste matcha",
      "confirmRequired": "Bekräfta lösenord krävs",
      "invalidToken": "Ogiltig eller saknad token.",
      "setSuccessToast": "Lösenordet har sparats",
      "setError": "Kunde inte spara nytt lösenord"
    },
    "verification": {
      "verifiedToast": "E-postadressen verifierades!",
      "failedToast": "E-postverifieringen misslyckades. Försök igen.",
      "resendSuccess": "Verifieringsmejl skickat",
      "resendError": "Kunde inte skicka verifieringsmejl. Försök igen senare.",
      "successTitle": "E-post verifierad!",
      "successSubtitle": "Din e-postadress har verifierats",
      "redirecting": "Omdirigerar till dashboard om {{count}} sekunder...",
      "goDashboardNow": "Gå till dashboard nu",
      "verifyingTitle": "Verifierar e-post",
      "verifyingText": "Vänta medan vi verifierar din e-postadress...",
      "title": "E-postverifiering",
      "checkInbox": "Kontrollera din inkorg",
      "instructions": "Vi har skickat en verifieringslänk till din e-postadress. Kontrollera inkorgen och klicka på länken för att aktivera ditt konto.",
      "sent": "Verifieringsmejl skickat",
      "resendIn": "Skicka igen om {{count}} sekunder",
      "resend": "Skicka verifieringsmejl igen",
      "helpText": "Du kan begära ett nytt verifieringsmejl efter nedräkningen. Kontrollera skräpposten om du inte ser mejlet i inkorgen."
    }
  },
  "feed": {
    "title": "Aktivitetsflöde",
    "empty": "Ingen aktivitet att visa ännu.",
    "viewCompany": "Visa företag"
  },
  "upgrade": {
    "title": "En Premiumfunktion",
    "description": "Den här funktionen ingår i Premiumplanen. Uppgradera för att låsa upp integrationer, anpassade fält och högre gränser.",
    "button": "Uppgradera till Premium",
    "dashboard": "Gå till dashboard"
  },
  "v2": {
    "language": "Språk",
    "nav": {
      "workspace": "Arbetsyta",
      "administration": "Administration",
      "citySettings": "Stadsinställningar",
      "mcp": "MCP-åtkomst",
      "ai": "AI-modell",
      "premium": "Premiumfunktion",
      "slack": "Slack"
    },
    "theme": {
      "appearance": "Utseende",
      "light": "Ljust",
      "dark": "Mörkt",
      "system": "Följ systemet"
    },
    "team": {
      "yourTeams": "Dina team",
      "switchFailed": "Kunde inte byta team. Försök igen.",
      "title": "Team",
      "subtitle": "Namn, format och personerna i teamet.",
      "generalTitle": "Allmänt",
      "generalHint": "Alla i teamet ser detta.",
      "name": "Teamnamn",
      "nameRequired": "Ange ett teamnamn.",
      "dateFormat": "Datum- och tidsformat",
      "dateFormatHint": "Används för alla datum i appen.",
      "currency": "Valuta",
      "currencyHint": "Används för MRR överallt.",
      "save": "Spara ändringar",
      "saved": "Teaminställningarna sparades",
      "saveFailed": "Teaminställningarna sparades inte. Försök igen.",
      "membersTitle": "Medlemmar",
      "rolesHint": "Inbjudna får ett mejl med en länk för att gå med.",
      "adminRole": "kan ändra inställningar, redigera och importera företag samt koppla CRM.",
      "userRole": "kan se företag, flödet och City View.",
      "seats": "{{used}} av {{total}} platser används",
      "seatsFull": "Alla platser är tagna. Uppgradera planen för att bjuda in fler.",
      "invite": "Bjud in",
      "member": "Medlem",
      "role": "Roll",
      "you": "du",
      "remove": "Ta bort",
      "removeNamed": "Ta bort {{email}}",
      "removeTitle": "Ta bort från teamet?",
      "removeBody": "{{email}} förlorar åtkomst till teamet direkt.",
      "removed": "{{email}} togs bort",
      "removeFailed": "Medlemmen kunde inte tas bort. Försök igen.",
      "inviteTitle": "Bjud in en medlem",
      "inviteBody": "De får ett mejl med en länk för att gå med i teamet.",
      "roleUserOption": "Användare: endast läsning",
      "roleAdminOption": "Admin: full åtkomst",
      "sendInvite": "Skicka inbjudan",
      "invited": "Inbjudan skickad till {{email}}",
      "inviteFailed": "Inbjudan skickades inte. Försök igen.",
      "planTitle": "Plan",
      "planHint": "Gränser, användning och fakturering finns på prenumerationssidan.",
      "openSubscription": "Öppna prenumeration",
      "dangerTitle": "Farozon",
      "dangerHint": "Detta går inte att ångra.",
      "wipeTitle": "Radera all teamdata",
      "wipeBody": "Tar bort alla företag och alla medlemmar från teamet.",
      "wipeAction": "Radera all data",
      "wipeConfirmTitle": "Radera all teamdata?",
      "wipeConfirmBody": "Alla företag, deras historik och alla medlemmar i teamet raderas. Det går inte att ångra.",
      "wipeType": "Skriv {{name}} för att bekräfta",
      "wiped": "All teamdata raderades",
      "wipeFailed": "Teamdatan raderades inte. Försök igen.",
      "roleChanged": "{{email}} är nu {{role}}",
      "roleFailed": "Rollen ändrades inte. Försök igen.",
      "roleFor": "Roll för {{email}}",
      "planIncludes": "Ingår i planen",
      "features": {
        "xls_import": "Excel-import",
        "crm_integrations": "CRM-integrationer (HubSpot, Zapier)",
        "custom_fields": "Anpassade fält",
        "advanced_analytics": "Avancerad analys",
        "api_access": "API-åtkomst",
        "priority_support": "Prioriterad support"
      }
    },
    "plan": {
      "manage": "Hantera plan"
    },
    "notifications": {
      "viewAll": "Visa alla aviseringar"
    },
    "dashboard": {
      "summary_one": "{{total}} företag från {{sources}} källor",
      "summary_other": "{{total}} företag från {{sources}} källor",
      "emptySummary": "Inga företag än",
      "skylineTitle": "Företag per status",
      "skylineHint": "En byggnad per status. Högre betyder fler företag.",
      "emptyTitle": "Din stad är tom",
      "emptyBody": "Importera ett kalkylark eller koppla HubSpot, så växer varje status upp här som en byggnad.",
      "importCta": "Importera företag",
      "connectCta": "Koppla ett CRM",
      "recentTitle": "Senast tillagda",
      "viewAll": "Visa alla företag",
      "noRecent": "Företag du lägger till visas här.",
      "sourcesTitle": "Var företagen kommer ifrån"
    },
    "auth": {
      "signInTitle": "Logga in på Metafor",
      "continueWithGoogle": "Fortsätt med Google",
      "orEmail": "eller med e-post",
      "email": "E-post",
      "forgotPassword": "Glömt lösenordet?",
      "signingIn": "Loggar in…",
      "wrongCredentials": "E-post och lösenord matchar inte. Kontrollera båda och försök igen.",
      "googleFailed": "Inloggningen med Google slutfördes inte. Försök igen.",
      "newHere": "Ny på Metafor?",
      "createAccount": "Skapa konto",
      "registerTitle": "Skapa ditt konto",
      "registerSubtitle": "Ditt teams företag, ritade som en stad.",
      "firstName": "Förnamn",
      "lastName": "Efternamn",
      "passwordMin6": "Använd minst 6 tecken",
      "haveAccount": "Har du redan ett konto?",
      "resetTitle": "Återställ ditt lösenord",
      "sendResetLink": "Skicka återställningslänk",
      "setPasswordTitle": "Välj ett nytt lösenord",
      "newPassword": "Nytt lösenord",
      "confirmPassword": "Upprepa nytt lösenord",
      "savePassword": "Spara lösenord",
      "invalidLink": "Länken saknar sin återställningskod. Öppna länken i mejlet igen, eller begär en ny.",
      "checkSpam": "Inget efter några minuter? Titta i skräpposten.",
      "wrongAccount": "Inte du?",
      "signInOther": "Logga in med ett annat konto",
      "strength": {
        "poor": "Mycket svagt",
        "weak": "Svagt",
        "fair": "Okej",
        "good": "Bra",
        "strong": "Starkt"
      }
    },
    "companies": {
      "count_one": "{{total}} företag",
      "count_other": "{{total}} företag",
      "searchPlaceholder": "Sök på namn eller CRM-ID",
      "clearSearch": "Rensa sökning",
      "filterByStatus": "Filtrera på status",
      "clearFilters": "Rensa",
      "clearAll": "Rensa sökning och filter",
      "noMatches": "Inga företag matchar sökningen och filtret.",
      "emptyTitle": "Inga företag än",
      "emptyBody": "Importera ett kalkylark, koppla ett CRM eller lägg till ett företag manuellt.",
      "exportFiltered": "Exportera den här vyn",
      "exportAll": "Exportera alla företag",
      "exportFailed": "Exporten slutfördes inte. Försök igen.",
      "loadFailed": "Företagen kunde inte laddas."
    },
    "company": {
      "notFoundTitle": "Företaget hittades inte",
      "notFoundBody": "Det kan ha raderats, eller så pekar länken till ett annat team.",
      "backToList": "Tillbaka till företag",
      "editLatest": "Redigera",
      "inactive": "Inaktivt",
      "deleteLatest": "Radera senaste posten",
      "deleteLatestBody": "Den senaste posten raderas. Företaget visar då sin föregående post, eller försvinner från listan om detta var den enda.",
      "deleteFailed": "Posten raderades inte."
    },
    "companyForm": {
      "createTitle": "Nytt företag",
      "createSubtitle": "Lägger till företaget med dess första post.",
      "editTitle": "Redigera post",
      "duplicateTitle": "Lägg till en post",
      "backToCompany": "Tillbaka till företaget",
      "duplicateInfo": "En ny post bevarar företagets historik: den utgår från de senaste värdena och dateras nu. Ändra det som skiljer sig och lägg till den.",
      "generalHint": "CRM-ID:t knyter ihop alla poster för ett företag.",
      "statusSection": "Status och intäkter",
      "statusHint": "Leadstatus krävs för leads.",
      "leadStatusRequired": "Krävs när statusen är Lead.",
      "recordSection": "Post",
      "recordHint": "När den här posten började gälla.",
      "active": "Aktivt företag",
      "choose": "Välj…",
      "fixErrors_one": "Rätta det markerade fältet för att fortsätta.",
      "fixErrors_other": "Rätta de {{count}} markerade fälten för att fortsätta.",
      "create": "Skapa företag",
      "saveChanges": "Spara ändringar",
      "addRecord": "Lägg till post",
      "recordAdded": "Posten har lagts till",
      "minLength": "Använd minst {{count}} tecken"
    },
    "history": {
      "subtitle": "Alla poster för företaget, senaste först.",
      "viewLabel": "Historikvy",
      "compact": "Ändringar",
      "full": "Alla fält",
      "spreadsheet": "Kalkylark",
      "none": "Inga poster än.",
      "created": "Företaget skapades.",
      "noChanges": "Inget ändrades i den här posten.",
      "empty": "(tomt)",
      "changedTo": "ändrades till",
      "date": "Datum",
      "source": "Källa",
      "editRecord": "Redigera post",
      "deleteRecord": "Radera post",
      "editTitle": "Redigera {{field}}",
      "editDescription": "Ändra värdet i den här posten.",
      "value": "Värde",
      "allNewer": "Ändra även alla nyare poster",
      "allNewerHint": "Nyare poster för företaget får samma värde.",
      "save": "Spara värde",
      "unchanged": "Värdet är oförändrat",
      "updated": "Värdet sparades",
      "updatedAll": "Värdet sparades i den här och alla nyare poster",
      "updateFailed": "Värdet sparades inte. Försök igen.",
      "loadFailed": "Historiken kunde inte laddas."
    },
    "import": {
      "subtitle": "Lägg till eller uppdatera företag från ett Excel-ark. Rader matchas på CRM-ID.",
      "drop": "Släpp en Excel-fil här, eller välj en",
      "dropHint": ".xlsx eller .xls, upp till 10 MB. Kolumner som i mallen.",
      "modified": "ändrad {{date}}",
      "processing": "Bearbetar rader…",
      "summary": "{{ok}} importerade, {{failed}} med fel, på {{seconds}} s",
      "another": "Importera en till fil"
    },
    "pagination": {
      "label": "Sidor",
      "range": "{{from}}–{{to}} av {{total}}",
      "perPage": "Per sida",
      "previous": "Föregående sida",
      "next": "Nästa sida",
      "page": "Sida {{page}}"
    },
    "feed": {
      "title": "Aktivitet",
      "subtitle": "Vad som ändrats bland dina företag, senaste först.",
      "today": "Idag",
      "yesterday": "Igår",
      "emptyTitle": "Ingen aktivitet än",
      "emptyBody": "Nya kunder, merförsäljning och churn visas här när de händer.",
      "end": "Det var allt.",
      "owner": "Ägare: {{name}}",
      "salesRep": "Säljare: {{name}}",
      "events": {
        "newCustomer": "<b>{{name}}</b> blev kund.",
        "upsell": "<b>{{name}}</b> uppgraderade. MRR upp {{amount}}.",
        "downgrade": "<b>{{name}}</b> nedgraderade. MRR ned {{amount}}.",
        "churn": "<b>{{name}}</b> har churnat.",
        "newLead": "<b>{{name}}</b> är ett nytt lead.",
        "lostLead": "<b>{{name}}</b> är ett förlorat lead.",
        "dataChange": "<b>{{name}}</b> uppdaterades.",
        "other": "<b>{{name}}</b> hade en händelse."
      }
    },
    "subscription": {
      "title": "Prenumeration",
      "subtitle": "Din plan, vad den innehåller och hur mycket du använder.",
      "currentPlan": "Nuvarande plan",
      "free": "Gratis",
      "premium": "Premium",
      "active": "Aktiv",
      "ending": "Avslutas",
      "perMonth": "per månad",
      "perYear": "per år",
      "renewsOn": "Förnyas {{date}}.",
      "endsOn": "Avslutas {{date}}; Premium gäller fram till dess.",
      "openSourceBody": "Alla funktioner, utan begränsningar.",
      "granted": "Ingår i ditt konto.",
      "grantedUntil": "Ingår i ditt konto till och med {{date}}.",
      "freeBody": "Grunderna för att komma igång. Uppgradera för CRM-integrationer, egna fält och högre gränser.",
      "upgrade": "Uppgradera till Premium",
      "manageBilling": "Hantera fakturering",
      "cancel": "Avsluta plan",
      "cancelTitle": "Avsluta Premium?",
      "cancelBody": "Premium gäller till {{date}}, sedan går teamet över till Gratis.",
      "cancelled": "Premium avslutas {{date}}",
      "cancelFailed": "Planen avslutades inte. Försök igen.",
      "resume": "Behåll Premium",
      "resumeTitle": "Behåll Premium?",
      "resumeBody": "Planen förnyas {{date}} som vanligt.",
      "resumed": "Premium förnyas",
      "resumeFailed": "Planen återupptogs inte. Försök igen.",
      "portalFailed": "Faktureringen öppnades inte. Försök igen.",
      "loadFailed": "Prenumerationen kunde inte laddas. Ladda om sidan för att försöka igen.",
      "notIncluded": "ingår inte",
      "usage": "Användning",
      "usageHint": "Mot planens gränser.",
      "members": "Teammedlemmar",
      "notInPlan": "Ingår inte i din plan",
      "limitReached": "Gränsen nådd",
      "nearLimit": "Nästan full",
      "chooseTitle": "Välj en plan",
      "chooseBody": "Byt eller avsluta när som helst på den här sidan.",
      "monthly": "Månadsvis",
      "yearly": "Årsvis, spara {{saving}}%",
      "freeNote": "För att prova Metafor.",
      "premiumNote": "Allt, med utrymme att växa.",
      "yearlyNote": "Faktureras en gång per år, {{saving}}% billigare än månadsvis.",
      "stripeNote": "Betalningen hanteras av Stripe.",
      "continueToPayment": "Fortsätt till betalning",
      "checkoutFailed": "Kassan öppnades inte. Försök igen.",
      "features": {
        "addCompanies": "Lägga till företag",
        "editCompanies": "Redigera företag",
        "importXls": "Excel-import",
        "cityView": "City View",
        "hubspot": "HubSpot-integration",
        "zapier": "Zapier-integration",
        "customFields": "Egna fält"
      }
    },
    "payment": {
      "successTitle": "Du har Premium",
      "successBody": "Integrationer, egna fält och de högre gränserna är aktiva nu. Planen och fakturorna finns på prenumerationssidan.",
      "errorTitle": "Betalningen gick inte igenom",
      "errorBody": "Inget drogs och planen ändrades inte. Oftast betyder det att kortet nekades eller har gått ut. Försök igen, eller använd ett annat kort.",
      "tryAgain": "Försök igen",
      "viewSubscription": "Visa prenumeration"
    },
    "hub": {
      "team": {
        "title": "Team",
        "body": "Namn, datumformat, valuta och medlemmar."
      },
      "subscription": {
        "title": "Prenumeration",
        "body": "Plan, användning och fakturering."
      },
      "crm": {
        "title": "CRM-integrationer",
        "body": "Koppla HubSpot och Zapier."
      },
      "customFields": {
        "title": "Egna fält",
        "body": "Extra fält på varje företag."
      },
      "mcp": {
        "title": "MCP-åtkomst",
        "body": "Nycklar för AI-assistenter och skript."
      },
      "ai": {
        "title": "AI-modell",
        "body": "Inbyggd agent eller egen Gemini-nyckel."
      },
      "slack": {
        "title": "Slack",
        "body": "Vecko- och månadssammanfattningar i era kanaler."
      }
    },
    "crm": {
      "subtitle": "Hämta in företag från ditt CRM och automationsverktyg.",
      "hubspot": "Synka företag, statusar och egna fält från HubSpot.",
      "zapier": "Skapa och uppdatera företag från tusentals appar.",
      "connected": "Ansluten",
      "notConnected": "Inte ansluten",
      "premiumOnly": "Integrationer ingår i Premium."
    },
    "hubspot": {
      "subtitle": "Företag synkas från HubSpot enligt schema och när du ber om det.",
      "loadFailed": "HubSpot-anslutningen kunde inte laddas. Ladda om sidan för att försöka igen.",
      "notConnected": "Inte ansluten",
      "notConnectedBody": "Anslut ett HubSpot-konto för att hämta in dess företag i Metafor. Du godkänner åtkomsten i HubSpot och kommer sedan tillbaka hit för att mappa fält.",
      "connect": "Anslut HubSpot",
      "afterConnect": "Godkänn åtkomsten i HubSpot och kom sedan tillbaka till den här fliken; anslutningen visas här av sig själv.",
      "preview": {
        "overview": {
          "title": "Se vad som synkats",
          "body": "Antal synkade företag, fördelat på status."
        },
        "fields": {
          "title": "Mappa fält",
          "body": "Välj vilka HubSpot-egenskaper som fyller MRR, ägare och dina egna fält."
        },
        "statuses": {
          "title": "Mappa statusar",
          "body": "Bestäm vilka HubSpot-värden som gör ett företag till lead, kund och så vidare."
        },
        "sync": {
          "title": "Välj omfång",
          "body": "Hur långt bak historiken går och om nya företag skapas."
        }
      },
      "connectedTo": "Ansluten till {{domain}}",
      "lastSync": "Senaste synk",
      "syncStatus": "Status",
      "never": "Aldrig",
      "sync": {
        "success": "Lyckades",
        "error": "Misslyckades",
        "in_progress": "Pågår",
        "not_started": "Inte körd än"
      },
      "syncNow": "Synka nu",
      "syncing": "Synkar…",
      "syncStarted": "Synken har startat. Du får en avisering när den är klar.",
      "syncRunning": "En synk pågår redan. Vänta tills den är klar.",
      "syncFailed": "Synken startade inte. Försök igen senare.",
      "overviewTitle": "Synkade företag",
      "overviewHint": "Företag som kom från HubSpot, efter nuvarande status.",
      "overviewFailed": "De synkade företagen kunde inte laddas.",
      "companiesSynced": "Synkade företag",
      "wipeAction": "Radera synkade företag",
      "wipeTitle": "Radera synkade företag?",
      "wipeBody": "Alla {{count}} företag som kom från HubSpot raderas, med historik. Anslutningen finns kvar; nästa synk hämtar dem igen.",
      "wiped": "Synkade företag raderades",
      "wipeFailed": "De synkade företagen raderades inte. Försök igen.",
      "fieldsTitle": "Fältmappning",
      "fieldsHint": "Vilken HubSpot-egenskap som fyller varje Metafor-fält. Namn, status och CRM-ID synkas alltid.",
      "fieldsFailed": "HubSpot-egenskaperna kunde inte laddas. Att ansluta HubSpot igen brukar lösa det.",
      "fields": {
        "mrr": "MRR",
        "mrrHint": "Tal som 7276, 7.276,00 SEK eller 7,2 kSEK förstås.",
        "csmId": "CSM-ID",
        "orgno": "Organisationsnummer",
        "owner": "Ägare",
        "ownerHint": "Som standard används företagets ägare i HubSpot.",
        "salesRep": "Säljare",
        "activityLevel": "Aktivitetsnivå"
      },
      "notMapped": "Inte mappad",
      "noOverride": "Företagsägare i HubSpot",
      "noCustomFields": "Teamet har inga egna fält än.",
      "searchFields": "Sök egenskaper…",
      "noFields": "Ingen egenskap matchar.",
      "statusesTitle": "Statusmappning",
      "statusesHint": "En HubSpot-egenskap avgör varje företags status i Metafor.",
      "statusField": "Statusegenskap i HubSpot",
      "chooseStatusField": "Välj en egenskap",
      "statusFieldHint": "Endast egenskaper med en fast lista av värden visas.",
      "statusesToSync": "Synka bara företag med dessa värden",
      "statusesToSyncHint": "Företag med andra värden tas inte med i synken.",
      "becomes": "Blir {{status}}",
      "chooseValues": "Välj värden",
      "searchValues": "Sök värden…",
      "noValues": "Inget värde matchar.",
      "selectAll": "Välj alla",
      "deselectAll": "Rensa alla",
      "selectedCount_one": "{{count}} värde",
      "selectedCount_other": "{{count}} värden",
      "removeValue": "Ta bort {{value}}",
      "syncTitle": "Synk",
      "syncHint": "Hur mycket historik som följer med och vad som skapas.",
      "historyFrom": "Importera historik från",
      "historyFromHint": "Poster från och med detta datum importeras. Lämna tomt för all historik.",
      "onlyExisting": "Uppdatera bara företag som redan finns i Metafor",
      "onlyExistingHint": "Nya HubSpot-företag skapas inte medan detta är på.",
      "unsaved": "Du har osparade ändringar.",
      "discard": "Förkasta",
      "save": "Spara inställningar",
      "saved": "HubSpot-inställningarna sparades",
      "saveFailed": "HubSpot-inställningarna sparades inte. Försök igen.",
      "disconnect": "Koppla från",
      "disconnectTitle": "Koppla från HubSpot?",
      "disconnectBody": "Synken stoppas. Redan synkade företag finns kvar i Metafor.",
      "removeAll": "Koppla från och radera data",
      "removeAllTitle": "Koppla från och radera HubSpot-data?",
      "removeAllBody": "Synken stoppas och alla företag som kom från HubSpot raderas, med historik.",
      "disconnected": "HubSpot kopplades från",
      "removedAll": "HubSpot kopplades från och dess data raderades",
      "disconnectFailed": "HubSpot kopplades inte från. Försök igen."
    },
    "zapier": {
      "subtitle": "Zapier kopplar Metafor till tusentals appar med en hemlig nyckel.",
      "open": "Öppna Zapier",
      "keyTitle": "API-nyckel",
      "keyHint": "Zapier använder nyckeln för att agera för teamet. Håll den hemlig.",
      "noKey": "Ingen nyckel än. Skapa en och klistra in den i Zapier.",
      "create": "Skapa API-nyckel",
      "created": "API-nyckeln skapades",
      "createFailed": "API-nyckeln skapades inte. Försök igen.",
      "show": "Visa nyckel",
      "hide": "Dölj nyckel",
      "copy": "Kopiera nyckel",
      "copied": "Nyckeln kopierades",
      "copyFailed": "Kunde inte kopiera. Markera nyckeln och kopiera den manuellt.",
      "rotate": "Byt nyckel",
      "rotateTitle": "Byta API-nyckel?",
      "rotateBody": "Den nuvarande nyckeln slutar fungera direkt. Zaps som använder den behöver den nya nyckeln.",
      "rotated": "Ny API-nyckel skapad; den gamla fungerar inte längre",
      "remove": "Radera nyckel",
      "removeTitle": "Radera API-nyckeln?",
      "removeBody": "Zaps som använder nyckeln slutar fungera.",
      "removed": "API-nyckeln raderades",
      "removeFailed": "API-nyckeln raderades inte. Försök igen.",
      "howTitle": "Kom igång",
      "steps": {
        "one": {
          "title": "Skapa en nyckel",
          "body": "Den visar Metafor att förfrågningar från Zapier kommer från dig."
        },
        "two": {
          "title": "Lägg till Metafor i Zapier",
          "body": "Klistra in nyckeln när Zapier frågar efter dina Metafor-uppgifter."
        },
        "three": {
          "title": "Bygg en Zap",
          "body": "Skapa eller uppdatera företag när något händer i en annan app."
        }
      }
    },
    "slack": {
      "subtitle": "Stadens sammanfattningar, i Slack varje måndag.",
      "loadFailed": "Slack-inställningarna kunde inte laddas. Ladda om sidan.",
      "notConfigured": "Slack är inte konfigurerat på servern än.",
      "premiumOnly": "Slack-sammanfattningar ingår i Premium.",
      "notConnected": "Inte ansluten",
      "notConnectedBody": "Anslut er Slack-arbetsyta och bjud sedan in @Metafor till kanalerna som ska få sammanfattningarna.",
      "connect": "Lägg till i Slack",
      "connectedToast": "Slack är anslutet. Bjud nu in @Metafor till en kanal.",
      "installExpired": "Slack-länken har gått ut. Försök igen.",
      "installFailed": "Slack anslöts inte. Försök igen.",
      "steps": {
        "connect": {
          "title": "Lägg till i Slack",
          "body": "Tillåt Metafor i er arbetsyta."
        },
        "invite": {
          "title": "Bjud in boten",
          "body": "Skriv /invite @Metafor i valfri kanal, offentlig eller privat."
        },
        "pick": {
          "title": "Välj sammanfattningar",
          "body": "Vecka, månad, kvartal eller år, per kanal."
        }
      },
      "workspace": "Arbetsyta",
      "workspaceHint": "Slack-arbetsytan som boten skriver i.",
      "timezone": "Tidszon",
      "timezoneHint": "Sammanfattningarna skickas på måndagar från 9:00 i den här tidszonen.",
      "timezoneSaved": "Tidszonen sparad",
      "saveFailed": "Inte sparat. Försök igen.",
      "disconnect": "Koppla från Slack",
      "disconnectTitle": "Koppla från Slack?",
      "disconnectBody": "Boten slutar skriva och lämnar er arbetsyta. Alla kanalers inställningar tas bort.",
      "disconnected": "Slack är frånkopplat",
      "disconnectFailed": "Slack kopplades inte från. Försök igen.",
      "channels": "Kanaler",
      "channelsHint": "Kanalerna boten finns i och vilka sammanfattningar var och en får. Medlemmar i kanalen kan också ändra det med /metafor.",
      "noChannels": "Boten finns inte i någon kanal än. Öppna kanalen i Slack som ska få sammanfattningarna och skriv:",
      "copyInvite": "Kopiera kommandot",
      "inviteCopied": "Kommandot kopierat",
      "copyFailed": "Kunde inte kopiera. Markera kommandot och kopiera det själv.",
      "waiting": "Väntar på att boten ska gå med i en kanal…",
      "private": "Privat kanal",
      "periods": {
        "week": "Varje vecka",
        "month": "Varje månad",
        "quarter": "Varje kvartal",
        "year": "Varje år"
      },
      "kinds": {
        "week": "veckans",
        "month": "månadens",
        "quarter": "kvartalets",
        "year": "årets"
      },
      "next": "Nästa: {{date}}, {{kind}} sammanfattning för {{name}}",
      "nothing": "Inget skickas hit. Kryssa i en sammanfattning för att börja.",
      "paused": "Pausat tills teamet har Premium igen.",
      "postNow": "Skicka senaste nu",
      "posted": "Skickade {{kind}} sammanfattning för {{name}} till #{{channel}}",
      "postFailed": "Sammanfattningen skickades inte. Försök igen.",
      "lastPost": "Senast skickad {{date}}",
      "errors": {
        "channel": "Boten kan inte skriva här längre. Bjud in den till kanalen igen.",
        "revoked": "Slack-åtkomsten har återkallats. Koppla från och anslut Slack igen.",
        "other": "Senaste utskicket misslyckades ({{code}})."
      },
      "scheduleTitle": "Varje måndag",
      "scheduleHint": "Varje kanal får den största sammanfattningen som just avslutats, bland dem den tar emot.",
      "schedule": {
        "year": {
          "when": "Första måndagen på året",
          "what": "Förra året"
        },
        "quarter": {
          "when": "Första måndagen i ett kvartal",
          "what": "Förra kvartalet"
        },
        "month": {
          "when": "Första måndagen i en månad",
          "what": "Förra månaden"
        },
        "week": {
          "when": "Övriga måndagar",
          "what": "Förra veckan, måndag till söndag"
        }
      }
    },
    "customFields": {
      "title": "Anpassade fält",
      "subtitle": "Extra fält som alla företag kan ha. De visas i företagsformuläret, historiken och HubSpot-fältmappningen.",
      "newLabel": "Nytt fält",
      "placeholder": "t.ex. Region eller Avtalslängd",
      "add": "Lägg till fält",
      "added": "Fältet ”{{name}}” har lagts till",
      "duplicate": "Det finns redan ett fält med det här namnet.",
      "saveFailed": "Fältet sparades inte. Försök igen.",
      "loadFailed": "De anpassade fälten laddades inte. Ladda om sidan och försök igen.",
      "emptyTitle": "Inga anpassade fält än",
      "emptyBody": "Lägg till ett fält ovan för att följa något som standardfälten inte täcker.",
      "addedOn": "Tillagt {{date}}",
      "rename": "Byt namn",
      "renameNamed": "Byt namn på {{name}}",
      "renamed": "Fältet heter nu ”{{name}}”",
      "delete": "Ta bort fält",
      "deleteNamed": "Ta bort {{name}}",
      "deleteTitle": "Ta bort ”{{name}}”?",
      "deleteBody": "Värdena tas bort från alla företag. Det går inte att ångra.",
      "deleted": "Fältet ”{{name}}” har tagits bort",
      "deleteFailed": "Fältet togs inte bort. Försök igen.",
      "footnote": "Om du byter namn på ett fält behålls värdena. Om du tar bort det försvinner de."
    },
    "alerts": {
      "title": "Varningar",
      "subtitle": "Bubblor över byggnaderna i er stad som behöver uppmärksamhet. Varje varning har ett villkor; en byggnad visar den första varning den matchar, i den här ordningen.",
      "upsellTitle": "Välj och anpassa alla 20 varningar med Premium",
      "upsellBody": "Er plan innehåller två varningar med fasta villkor. Med Premium kan ni slå på vilken varning som helst och bestämma villkoret, även med era egna fält.",
      "upgrade": "Se Premium",
      "premium": "Premium",
      "includedInFree": "Ingår i Free",
      "loadFailed": "Det gick inte att läsa in varningarna.",
      "saveFailed": "Det gick inte att spara varningen.",
      "saved": "{{name}} sparad",
      "restored": "{{name}} är återställd",
      "switchedOn": "{{name}} är på",
      "switchedOff": "{{name}} är av",
      "toggleNamed": "Visa {{name}}",
      "chooseFieldFirst": "Välj ett fält först",
      "chooseField": "Välj ett fält",
      "loadingFields": "Läser in fält…",
      "searchFields": "Sök fält…",
      "noFields": "Inget fält matchar.",
      "calculated": "beräknat",
      "customField": "eget fält",
      "operator": "Jämförelse",
      "value": "Värde",
      "chooseValue": "Välj ett värde",
      "restore": "Återställ",
      "restoreNamed": "Återställ {{name}}",
      "missingField": "Fältet finns inte längre. Välj ett annat.",
      "customFieldsUnavailable": "Egna fält kan inte läsas in just nu, så bara de inbyggda fälten visas. Varningar som redan använder egna fält fungerar som vanligt.",
      "customFieldUnavailable": "Varningen använder ett eget fält som inte kan läsas in just nu.",
      "noTrigger": "Inget villkor",
      "footnote": "Beräknade fält räknas fram av staden ur varje företags historik, per datumet på tidslinjen.",
      "items": {
        "crisis": {
          "label": "Kris",
          "hint": "Ett stort tapp som kräver åtgärd nu"
        },
        "urgent": {
          "label": "Brådskande",
          "hint": "Något att ta hand om i dag"
        },
        "attention": {
          "label": "Behöver uppmärksamhet",
          "hint": "Värt att titta på snart"
        },
        "blocked": {
          "label": "Blockerad",
          "hint": "Fast på något utanför er kontroll"
        },
        "declining": {
          "label": "Minskande MRR",
          "hint": "Intäkterna från kunden minskar"
        },
        "unhappy": {
          "label": "Missnöjd",
          "hint": "Kunden är inte nöjd"
        },
        "needs-input": {
          "label": "Behöver svar",
          "hint": "Väntar på ett svar från er"
        },
        "person-needed": {
          "label": "Saknar ansvarig",
          "hint": "Ingen tar hand om den"
        },
        "maintenance": {
          "label": "Underhåll",
          "hint": "Dags för en avstämning"
        },
        "idle": {
          "label": "Vilande affär",
          "hint": "Ett lead eller en affärsmöjlighet som har stannat upp"
        },
        "delivery": {
          "label": "Leverans",
          "hint": "Något att leverera eller starta upp"
        },
        "in-progress": {
          "label": "Pågår",
          "hint": "Arbete pågår"
        },
        "conversation": {
          "label": "Samtal",
          "hint": "En pågående dialog"
        },
        "opportunity": {
          "label": "Ny affärsmöjlighet",
          "hint": "En affär som just öppnats"
        },
        "money-event": {
          "label": "Stor kund",
          "hint": "Ett stort avtal"
        },
        "high-activity": {
          "label": "Hög aktivitet",
          "hint": "Mycket händer"
        },
        "improving": {
          "label": "Växande MRR",
          "hint": "Intäkterna från kunden ökar"
        },
        "completed": {
          "label": "Ny kund",
          "hint": "Nyss vunnen"
        },
        "happy": {
          "label": "Nöjd",
          "hint": "Kunden är nöjd"
        },
        "notable-event": {
          "label": "Toppkund",
          "hint": "En av era största kunder"
        }
      }
    },
    "mcp": {
      "title": "MCP-åtkomst",
      "subtitle": "Låt en AI-assistent som Claude eller Cursor läsa och uppdatera teamets företag via MCP.",
      "endpoint": "Endpoint",
      "endpointHint": "Adressen som din MCP-klient ansluter till.",
      "copyEndpoint": "Kopiera endpoint",
      "endpointCopied": "Endpoint kopierad",
      "keys": "Nycklar",
      "keysHint": "En nyckel agerar som personen som skapade den, med dennes roll. Återkalla nycklar du inte längre använder.",
      "noKeys": "Inga nycklar än. Skapa en för varje assistent eller enhet du ansluter.",
      "loadFailed": "Nycklarna laddades inte. Ladda om sidan och försök igen.",
      "unnamed": "Namnlös nyckel",
      "createdOn": "Skapad {{date}}",
      "createdBy": "Skapad {{date}} av {{name}}",
      "generate": "Skapa nyckel",
      "generateTitle": "Skapa en MCP-nyckel",
      "generateBody": "Döp nyckeln efter var du ska använda den, så att du kan skilja nycklarna åt senare.",
      "nameLabel": "Namn (valfritt)",
      "namePlaceholder": "t.ex. Claude på min laptop",
      "generateFailed": "Nyckeln skapades inte. Försök igen.",
      "revealTitle": "Din nya MCP-nyckel",
      "revealBody": "Lägg till den i din MCP-klient med någon av uppsättningarna nedan.",
      "keyLabel": "MCP-nyckel",
      "onlyOnce": "Kopiera nyckeln nu. Den visas inte igen; om du tappar bort den, återkalla den och skapa en ny.",
      "copyKey": "Kopiera nyckel",
      "keyCopied": "Nyckeln kopierad",
      "done": "Jag har kopierat nyckeln",
      "copyFailed": "Kunde inte kopiera. Markera texten och kopiera den manuellt.",
      "revoke": "Återkalla",
      "revokeTitle": "Återkalla ”{{name}}”?",
      "revokeBody": "Assistenter som använder nyckeln förlorar åtkomsten direkt. Det går inte att ångra.",
      "revoked": "Nyckeln ”{{name}}” har återkallats",
      "revokeFailed": "Nyckeln återkallades inte. Försök igen.",
      "connect": "Anslut en klient",
      "connectHint": "Ersätt <your key> med en nyckel från ovan.",
      "client": "MCP-klient",
      "jsonConfig": "JSON-konfiguration",
      "otherClients": "Andra klienter",
      "copySnippet": "Kopiera uppsättning",
      "snippetCopied": "Uppsättningen kopierad",
      "clientHint": {
        "claude": "Kör det här i en terminal.",
        "json": "För Cursor och andra klienter som läser en mcpServers-fil, t.ex. .cursor/mcp.json.",
        "other": "Lägg till en fjärrserver (Streamable HTTP) med den här URL:en och headern."
      }
    },
    "ai": {
      "title": "AI-modell",
      "subtitle": "Modellen bakom assistenten här och agenten i din 3D-stad.",
      "upsellTitle": "Använd din egen Gemini-nyckel",
      "upsellBody": "Med Premium kan assistenten och stadens agent köras på ert teams egen Gemini API-nyckel: er kvot, er modell.",
      "loadFailed": "Det gick inte att läsa in AI-inställningarna.",
      "source": "Modell",
      "sourceHint": "Båda agenterna använder samma val.",
      "builtin": "Inbyggd agent",
      "builtinBody": "Metafors Gemini. Inget att ställa in.",
      "builtinMissing": "Inte tillgänglig på den här servern just nu.",
      "own": "Egen Gemini-nyckel",
      "ownBody": "Agenterna anropar Gemini med er nyckel. Slutar nyckeln fungera visar de ett fel i stället för att byta till vår.",
      "key": "Gemini API-nyckel",
      "keyHint": "Lagras krypterad och visas aldrig igen. Den kontrolleras med en kort förfrågan innan den sparas.",
      "getKey": "Skaffa en nyckel i Google AI Studio",
      "keyLabel": "API-nyckel",
      "replaceKey": "Byt till en ny nyckel",
      "model": "Modell (valfritt)",
      "modelPlaceholder": "Automatiskt",
      "modelHint": "Ett Gemini-modell-id, till exempel gemini-flash-latest. Lämna tomt så väljer Metafor en som svarar.",
      "notConfigured": "Servern kan inte lagra nycklar än. Be Metafors support att aktivera det.",
      "verified": "Fungerade {{date}} med {{model}}",
      "test": "Testa",
      "testOk": "Nyckeln fungerar.",
      "testFailed": "Nyckeln fungerade inte.",
      "remove": "Ta bort",
      "removeTitle": "Ta bort er Gemini-nyckel?",
      "removeBody": "Agenterna går tillbaka till den inbyggda modellen. Ni kan lägga till en nyckel igen när som helst.",
      "removed": "Nyckeln är borttagen. Agenterna använder den inbyggda modellen.",
      "removeFailed": "Det gick inte att ta bort nyckeln.",
      "checking": "Kontrollerar nyckeln…",
      "savedOwn": "Sparat. Agenterna använder nu er Gemini-nyckel.",
      "savedBuiltin": "Sparat. Agenterna använder den inbyggda modellen.",
      "saveFailed": "Det gick inte att spara AI-inställningarna."
    },
    "profile": {
      "title": "Profil",
      "subtitle": "Ditt namn, din inloggning och hur Metafor ser ut för dig.",
      "details": "Dina uppgifter",
      "detailsHint": "Kollegor ser ditt namn i medlemslistan och i företagens historik.",
      "inTeam": "i {{team}}",
      "name": "Namn",
      "nameMin": "Använd minst 2 tecken",
      "nameSaved": "Namnet har sparats",
      "nameFailed": "Namnet sparades inte. Försök igen.",
      "email": "E-post",
      "verified": "Verifierad",
      "notVerified": "Inte verifierad",
      "viaGoogle": "Du loggar in med Google.",
      "viaPassword": "Du loggar in med e-post och lösenord.",
      "sendVerification": "Skicka verifieringsmejl",
      "verificationSent": "Verifieringsmejl skickat till {{email}}",
      "verificationFailed": "Verifieringsmejlet skickades inte. Försök igen om en minut.",
      "password": "Lösenord",
      "passwordHint": "Använd minst 8 tecken. Du förblir inloggad på den här enheten.",
      "currentPassword": "Nuvarande lösenord",
      "currentRequired": "Ange ditt nuvarande lösenord",
      "samePassword": "Välj ett annat lösenord än det nuvarande",
      "changePassword": "Byt lösenord",
      "passwordChanged": "Lösenordet har bytts",
      "wrongPassword": "Det är inte ditt nuvarande lösenord.",
      "weakPassword": "Välj ett starkare lösenord.",
      "tooManyAttempts": "För många försök. Vänta några minuter och försök igen.",
      "passwordFailed": "Lösenordet byttes inte. Försök igen.",
      "googlePassword": "Du loggar in med Google, så det finns inget Metafor-lösenord att byta. Hantera det i ditt Google-konto.",
      "noPassword": "Ditt konto har inget lösenord att byta.",
      "openGoogle": "Öppna Google-kontot",
      "preferences": "Inställningar",
      "preferencesHint": "Sparas på den här enheten."
    },
    "assistant": {
      "title": "Assistent",
      "subtitle": "Fråga om era företag, eller låt den göra ändringar som du godkänner.",
      "ask": "Fråga assistenten",
      "openFull": "Öppna helsida",
      "newChat": "Ny chatt",
      "newChatTitle": "Starta en ny chatt?",
      "newChatBody": "Den här konversationen raderas. Assistenten kommer inte ihåg den.",
      "resetFailed": "Chatten rensades inte. Försök igen.",
      "loadFailed": "Konversationen laddades inte.",
      "retry": "Försök igen",
      "you": "Du",
      "thinking": "Tänker",
      "replyFailed": "Svaret kom inte fram. Skicka ditt meddelande igen.",
      "emptyTitle": "Vad kan jag hjälpa till med?",
      "emptyBody": "Jag kan slå upp företag och siffror, och göra ändringar som att skapa ett företag eller bjuda in en kollega. Du godkänner varje ändring innan den görs.",
      "suggest": {
        "lookUp": "Slå upp något",
        "change": "Gör en ändring",
        "topCustomers": "Vilka kunder har högst MRR?",
        "newLeads": "Visa våra öppna leads",
        "dashboard": "Sammanfatta dashboarden",
        "createCompany": "Skapa ett företag som heter Acme Corp",
        "invite": "Bjud in john@example.com till teamet som admin",
        "renameTeam": "Byt namn på teamet till Acme Sales"
      },
      "placeholder": "Fråga vad som helst om era företag",
      "answerFirst": "Godkänn eller avböj åtgärden ovan för att fortsätta",
      "send": "Skicka",
      "stop": "Stoppa",
      "footnote": "Assistenten kan ha fel. Kontrollera ändringar innan du godkänner dem.",
      "approve": "Godkänn",
      "decline": "Avböj",
      "nothingYet": "Inget ändras förrän du godkänner.",
      "openCompany": "Öppna företaget",
      "gone": "Den här åtgärden väntar inte längre på svar.",
      "executeFailed": "Åtgärden kördes inte. Kontrollera anslutningen och försök igen.",
      "lookupFailed": "Kunde inte slutföra: {{what}}",
      "andMore": "och {{count}} till",
      "status": {
        "pending": "Behöver godkännas",
        "running": "Körs",
        "completed": "Klar",
        "failed": "Misslyckades",
        "denied": "Avböjd"
      },
      "fields": {
        "email": "E-post",
        "role": "Roll",
        "newName": "Nytt namn",
        "name": "Namn",
        "status": "Status",
        "mrr": "MRR",
        "crmId": "CRM-ID",
        "companies_one": "{{count}} företag",
        "companies_other": "{{count}} företag"
      },
      "tools": {
        "list_companies": {
          "read": "Gick igenom företag"
        },
        "get_company": {
          "read": "Öppnade ett företag"
        },
        "company_history": {
          "read": "Läste ett företags historik"
        },
        "dashboard_stats": {
          "read": "Kollade dashboarden"
        },
        "find_settings": {
          "read": "Letade upp var en inställning finns"
        },
        "create_company": {
          "title": "Skapa ett företag"
        },
        "upsert_companies": {
          "title": "Skapa eller uppdatera företag"
        },
        "invite_user": {
          "title": "Bjud in en kollega"
        },
        "rename_team": {
          "title": "Byt namn på teamet"
        }
      },
      "done": {
        "createCompany": "{{name}} skapades",
        "upsertCompanies": "{{created}} skapade, {{updated}} uppdaterade, {{failed}} misslyckades"
      }
    },
    "common": {
      "retry": "Försök igen"
    },
    "footer": {
      "label": "Sidfot",
      "support": "Support",
      "privacy": "Integritet"
    },
    "limits": {
      "title": "Planens gräns nådd",
      "upgrade": "Uppgradera",
      "companies_one": "Din plan tillåter {{count}} företag. Uppgradera för att lägga till fler.",
      "companies_other": "Din plan tillåter {{count}} företag. Uppgradera för att lägga till fler.",
      "users_one": "Din plan tillåter {{count}} medlem. Uppgradera för att bjuda in fler.",
      "users_other": "Din plan tillåter {{count}} medlemmar. Uppgradera för att bjuda in fler.",
      "integrations_zero": "Din plan innehåller inga integrationer. Uppgradera för att ansluta en.",
      "integrations_one": "Din plan tillåter {{count}} integration. Uppgradera för att ansluta fler.",
      "integrations_other": "Din plan tillåter {{count}} integrationer. Uppgradera för att ansluta fler.",
      "hubspotRefused": "HubSpot anslöts inte: din plan har inte plats för fler integrationer.",
      "hubspotFailed": "HubSpot kunde inte anslutas. Försök igen.",
      "importRefused": "Inget importerades: gränsen för företag är nådd.",
      "skipped_one": "{{count}} företag från ditt CRM importerades inte",
      "skipped_other": "{{count}} företag från ditt CRM importerades inte"
    },
    "trial": {
      "planName": "Premium-provperiod",
      "badge": "Provperiod",
      "body": "Alla Premium-funktioner till {{date}}. Därefter går teamet över till Free, om ni inte väljer en plan.",
      "endsOn": "Er Premium-provperiod slutar {{date}}.",
      "daysLeft_one": "{{count}} dag kvar.",
      "daysLeft_other": "{{count}} dagar kvar.",
      "ended": "Er Premium-provperiod har slutat.",
      "endedBody": "Teamet har nu Free. All data finns kvar; välj en plan för att få tillbaka HubSpot, Zapier och de högre gränserna.",
      "choosePlan": "Välj en plan",
      "close": "Stäng"
    }
  }
}
